import produce from "immer";
import IQualityReportsReducer from "models/IQualityReportsReducer";
import { actionTypes } from "./actions";
import { qualityReportSorting as defaultSorting } from "constants/sorting";

const initialState: IQualityReportsReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  error: null,
  typeOptions: []
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_QUALITY_REPORTS_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_QUALITY_REPORTS_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_QUALITY_SELECT_OPTIONS_REQUEST:
        draftState.typeOptions = [];
        break;
      case actionTypes.GET_QUALITY_SELECT_OPTIONS_SUCCESS:
        draftState.typeOptions = action.payload;
        break;
    }
  });
